import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const legal_insurance_cancelled_by = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('insurance_was_voided_before')]:
        BaseSchema_LegalBasis3BasicRolandDe.shape.insurance_was_voided_before.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.cancelled_by_insurer.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('insurance_was_voided_before'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.cancelled_by_insurer.false',
            },
            value: false,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.cancelled_by_insurer.true',
            },
            value: true,
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('insurance_was_voided_before'),
      valueToStepName: {
        false: 'legal_insurance_cancellation_date',
        true: FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default legal_insurance_cancelled_by
